import React, { PureComponent } from 'react';
import PropTypes from "prop-types";
import CaptchaSettings from '../captchaSettings';
import InvisibleRecaptchaFunctions from '../base/invisibleRecaptchaHelper';

class TurnstileRecaptcha extends PureComponent {

    scriptId = 'turnstile_loading_script';
    placeholderDiv = React.createRef();
    placeholderDivId = `trnstl-${Math.random().toString(36).substring(7)}`;
    turnstileSrc = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    captcha = undefined;
    captchaWidget = undefined;
    captchaErrors = [];

    componentDidMount() {
        console.log(`${this.placeholderDivId} componentDidMount 0`);
        if (window && window.turnstile) {
            console.log(`${this.placeholderDivId} componentDidMount 1`);
            this.setCaptcha();
        } else {
            console.log(`${this.placeholderDivId} componentDidMount 2`);
            this.injectGoogleReCaptchaScript();
        }
    }

    injectGoogleReCaptchaScript = () => {
        console.log(`${this.placeholderDivId} injectturnstle script 1 : setup event listener`);
        window.addEventListener("turnstileOnReady", this.handleOnReady);
        if (!document.getElementById(this.scriptId)) {
            console.log(`${this.placeholderDivId} injectturnstle script 1 : load script`);
            const head = document.getElementsByTagName('head')[0];
            const js = document.createElement('script');
            js.id = this.scriptId;
            js.src = `${this.turnstileSrc}?onload=onloadTurnstileCallback`;
            js.async = true;

            head.appendChild(js);
            window.onloadTurnstileCallback = this.onloadCallback; //  this.onloadCallback;
            // window.onloadTurnstileCallback = function () {
            //     turnstile.render("#example-container", {
            //         sitekey: "<YOUR_SITE_KEY>",
            //         callback: function (token) {
            //             console.log(`Challenge Success ${token}`);
            //         },
            //     });
            // };
        }
    };

    onloadCallback = () => {
        console.log(`${this.placeholderDivId} dispatchEvent`);
        window.dispatchEvent(
            new Event("turnstileOnReady")
        );
    };

    handleOnLoad = () => {
        console.log(`${this.placeholderDivId} handleOnLoad 0`);
        if (!window || window && !window.turnstile) {
            console.log(`${this.placeholderDivId} handleOnLoad 1`);
            setTimeout(this.handleOnLoad, 1000);
        } else {
            console.log(`${this.placeholderDivId} handleOnLoad 2`);
            this.setCaptcha();
        }
    };

    handleOnReady = () => {
        console.log(`${this.placeholderDivId} handleOnReady 0`);
        if (!window || (window && !window.turnstile)) {
            console.log(`${this.placeholderDivId} handleOnReady 1`);
            setTimeout(this.handleOnReady, 1000);
        } else {
            console.log(`${this.placeholderDivId} handleOnReady 2`);
            this.setCaptcha();
        }
    };

    // setCaptcha = () => {
    //     console.log('setCaptcha');
    //     this.captcha = window.grecaptcha;
    //     this.captchaWidget = this.captcha.render(this.placeholderDivId, {
    //         sitekey: this.props.sitekey,
    //         callback: this.props.verifyCallback,
    //         size: 'invisible'
    //     });
    // };

    setCaptcha = () => {
        console.log(`${this.placeholderDivId} setCaptcha 0`);
        // const turnstileInstance = window.turnstile;
        // if (turnstileInstance.render ==='undefined' || !turnstileInstance.render) {
        //     console.log(`${this.placeholderDivId} setCaptcha 1`);
        //     turnstileInstance.ready(() => {
        //         this.setCaptcha();
        //     });
        if (!window || (window && !window.turnstile)) {
            console.log(`${this.placeholderDivId} setCaptcha 1`);
            setTimeout(this.setCaptcha, 1000);
        } else {
            console.log(`${this.placeholderDivId} setCaptcha 2`);
            //this.captcha = turnstileInstance;
            window.turnstile.render(this.placeholderDiv.current, {
                sitekey: CaptchaSettings.turnstile,
                execution: 'execute',
                callback: this.verifyCallback,
                'error-callback': this.verifyFailure,
                size: 'invisible'
            });
        }
    };

    reset = () => {
        console.log(`reset turnstileRecaptcha ${this.placeholderDivId}`);
        if (window.turnstile) {
            window.turnstile.reset(('#'+this.placeholderDivId));
        }
    };

    execute = () => {
        console.log(`execute turnstileRecaptcha ${this.placeholderDivId}`);
        // if(!this.captcha && window.turnstile) {
        //     this.setCaptcha();
        // }
        if (window.turnstile) {
            window.turnstile.execute(this.placeholderDiv.current);
        } else {
            console.log('turnstileRecaptcha is not yet enabled')
        }
    };

    verifyCallback = (response) => {
        console.log('turnstile verifyCallback');
        this.props.verifyCallback({key: 'turnstile_response', value: response, errors: this.captchaErrors})
    };

    verifyRacaptchaCallback = (response) => {
        console.log('turnstile -> recapctha verifyCallback');
        this.props.verifyCallback({key: 'g_recaptcha_response', value: response, errors: this.captchaErrors})
    };

    verifyFailure = (errorCode) => {
        console.log('verifyFailure', errorCode);
        //this.props.verifyFailure(errorCode);
        const code = errorCode.toString();
        this.captchaErrors.push(errorCode);
        switch(true) {
            case (code === '110500' || code === '600010'):
                console.log('browser not supported');
                InvisibleRecaptchaFunctions.execute(this.verifyRacaptchaCallback);
                break;
            case code.startsWith('11062'):
                console.log('reset');
                window.turnstile.reset(('#' + this.placeholderDivId));
                break;
            case (code.startsWith('100') || code.startsWith('300') || code.startsWith('600')):
                console.log('reload page');
                this.props.verifyFailure({captcha: 'Bot protection failed or token expired, please reload the page and try again'}, false);
                break;
            default:
                return '';
        }
    };

    render() {
        console.log(`render turnstile ${this.placeholderDivId}`);
        return  (
            <div id={this.placeholderDivId} ref={this.placeholderDiv} />
        );
    }
}

TurnstileRecaptcha.propTypes = {
    verifyCallback: PropTypes.func.isRequired
};
export default TurnstileRecaptcha;